<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import {BIconCaretLeftFill, BIconCaretRightFill, BIconExclamationSquare, BIconExclamationCircleFill} from 'bootstrap-vue'
import moment from "moment-timezone";
import systemCode from "@/mixins/systemCode";
import {mapGetters} from "vuex";
import router from "@/mixins/router";
import store from '@/state/store';

export default {
  name: "Projects",
  page: {
    title: "作業日報一覧（運搬）",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [systemCode, router],
  components: {
    Layout,
    BIconExclamationSquare,
    BIconExclamationCircleFill,
    BIconCaretRightFill,
    BIconCaretLeftFill
  },
  data() {
    return {
      data: [],
      conditionDate: [],
      isLoading: false,
      user: null,
      filters: {
        date: this.$route.query.date !== undefined && this.$route.query.date ? this.$route.query.date : moment().format("YYYY-MM-DD"),
        factory_id: this.$route.query.id,
        discharger_site_id:this.$route.query.discharger_site_id || null,
        zz_vendor_site_4_id: this.$route.query.zz_vendor_site_4_id,
        factory_name: '',
        is_factory: true
      },
      queryRedirectFactory: {
        fromMenu: 0,
        date: null,
        showAlert: 1,
        isDefault: true
      },
      DAY_OF_WEEKS: ['日', '月', '火', '水', '木', '金', '土'],
      zzWorkOrderTypes: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    backToList() {
      this.queryRedirectFactory.date = this.filters.date
      this.$router.push({path: '/factories', query: this.queryRedirectFactory});
    },
    async getData() {
      this.isLoading = true;
      const sendApi = await this.$http.get(apiEndpoints.daily_report_factory, this.filters);
      const {status, data} = sendApi;

      if (status && data.result) {
        if (data.result.dailyReports.length !== 0 && this.filters.is_factory) {
          this.data = data.result.dailyReports;
          this.conditionDate = data.result.condition;
          this.user = data.result.user;
        } else if (data.result.dailyReports.length !== 0 && !this.filters.is_factory) {
          this.$router.push({path: '/daily-reports', query: this.filters});
        } else {
          this.filters.is_factory = true
          const sendApi = await this.$http.get(apiEndpoints.daily_report_factory, this.filters);
          const {status, data} = sendApi;
          if (status && data.result) {
            if (data.result.dailyReports.length !== 0) {
              this.data = data.result.dailyReports;
              this.conditionDate = data.result.condition;
              this.user = data.result.user;
            } else {
              this.queryRedirectFactory.date = this.filters.date
              this.$router.push({path: '/factories', query: this.queryRedirectFactory});
            }
          }
        }
      }
      this.isLoading = false;
      this.$nextTick(() => {
        this.scrollToSchedule()
      });
    },
    prevDate() {
      this.filters.date = moment(this.filters.date, "YYYY-MM-DD").subtract(1, 'days').format("YYYY-MM-DD");
      this.queryRedirectFactory.showAlert = 0
      this.filters.is_factory = false
      this.getData()
    },
    nextDate() {
      this.filters.date = moment(this.filters.date, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
      this.queryRedirectFactory.showAlert = 0
      this.filters.is_factory = false
      this.getData()
    },
    showBadge6(item, index) { // 処分完了ステータス
      if (item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id] === undefined) return ''
      let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
      let conditionStatusDisposal = zzWorkOrderTypeId == this.$constant.work_order_type.disposal
      if (conditionStatusDisposal) {
        if (! item.is_schedule_canceled && ! item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return '処分未完了'
        if (! item.is_schedule_canceled && item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return '処分完了'
      }
      if (item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id] === undefined) return ''
      if (! item.is_schedule_canceled && item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return '完了'
      if (! item.is_schedule_canceled && ! item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return '未完了'
      if (item.is_schedule_canceled) return 'キャンセル'
      return ''
    },
    showBadge7(item, index) { // 搬入完了ステータス
      if (item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id] === undefined) return ''
      let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
      let conditionStatusDisposal = zzWorkOrderTypeId == this.$constant.work_order_type.disposal
      if (conditionStatusDisposal) {
        if (! item.is_schedule_canceled && ! item['is_treatment_accepted_' + this.filters.zz_vendor_site_4_id]) return '搬入未完了'
        if (! item.is_schedule_canceled && item['is_treatment_accepted_' + this.filters.zz_vendor_site_4_id]) return '搬入完了'
      }
      return ''
    },
    getDayAlert(){
      return  this.findDayAlert()?.system_code_value
    },
    formatDateAlert(item) {
      let date = item.updated_at
      if (! date) {
        date = item.created_at
      }

      let dateOrigin = moment(date, "YYYY-MM-DD HH:mm:ss")
      return '更新日' + dateOrigin.format('YYYY年MM月DD日') + '（' + this.DAY_OF_WEEKS[dateOrigin.day()] + '）'
    },
    formatMonthDayAlert(item) {
      let date = item.updated_at
      if (! date) {
        date = item.created_at
      }

      let dateOrigin = moment(date, "YYYY-MM-DD HH:mm:ss")
      return '更新日：' + dateOrigin.format('MM月DD日')
    },
    showDateAlert(item) {
      if (! item.work_order_json) return false
      let date = item.work_order_json.updated_at
      if (! date) {
        date = item.work_order_json.created_at
      }
      let dateOrigin = moment(date, "YYYY-MM-DD HH:mm:ss")
      let addDay = dateOrigin.add(this.getDayAlert(), 'days').format("YYYY-MM-DD");
      let current = moment().format("YYYY-MM-DD")
      return current <= addDay;
    },
    getColorBadge6(item, index) {
      if (item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id] === undefined) return this.$constant.statusHandle.cancel
      let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
      let conditionStatusDisposal = zzWorkOrderTypeId == this.$constant.work_order_type.disposal
      if (conditionStatusDisposal) {
        if (! item.is_schedule_canceled && ! item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.disposal_incomplete
        if (! item.is_schedule_canceled && item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.disposal_complete
      }

      if (! item.is_schedule_canceled && item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.complete
      if (! item.is_schedule_canceled && ! item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.incomplete
      if (item.is_schedule_canceled) return this.$constant.statusHandle.cancel
      return this.$constant.statusHandle.cancel
    },
    getColorTextBadge6(item, index) {
      let color = this.getColorBadge6(item, index)
      if (color == this.$constant.statusHandle.disposal_incomplete) {
        return this.$constant.statusHandle.disposal_complete_gray
      }
      return '#ffffff'
    },
    getColorBadge7(item, index) {
      if (item['is_treatment_completed_' + this.filters.zz_vendor_site_4_id] === undefined) return this.$constant.statusHandle.cancel
      let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
      let conditionStatusDisposal = zzWorkOrderTypeId == this.$constant.work_order_type.disposal
      if (conditionStatusDisposal) {
        if (! item.is_schedule_canceled && ! item['is_treatment_accepted_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.disposal_incomplete
        if (! item.is_schedule_canceled && item['is_treatment_accepted_' + this.filters.zz_vendor_site_4_id]) return this.$constant.statusHandle.disposal_complete
      }
      return this.$constant.statusHandle.cancel
    },
    getColorTextBadge7(item, index) {
      let color = this.getColorBadge7(item, index)
      if (color == this.$constant.statusHandle.disposal_incomplete) {
        return this.$constant.statusHandle.disposal_complete_gray
      }
      return '#ffffff'
    },
    getListName(type, item) {
      if (!item.schedule) {
        return '';
      }
      if (!item.schedule.waste_or_services_by_schedule.length) {
        return '';
      }

      return item.schedule.waste_or_services_by_schedule.map(waste_or_services_by_schedule => {
        if (type === 'vendor') {
          return waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.vendor?.name;
        } else {
          return waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name;
        }
      }).filter(x => !!x).join('<br>');
    },
    getListAddress(type, item) {
      if (!item.schedule) {
        return '';
      }
      if (!item.schedule.waste_or_services_by_schedule.length) {
        return '';
      }

      return item.schedule.waste_or_services_by_schedule.map(waste_or_services_by_schedule => {
        let data = waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment;

        if (type === 'vendor') {
          return [
            this.$helpers.formatZipCode(data?.vendor?.zip),
            data?.vendor?.address_1,
            data?.vendor?.address_2,
            data?.vendor?.address_3,
            data?.vendor?.address_4,
          ].filter(x => !!x).join('')
        } else {
          return [
            this.$helpers.formatZipCode(data?.zip),
            data?.address_1,
            data?.address_2,
            data?.address_3,
            data?.address_4,
          ].filter(x => !!x).join('')
        }
      }).filter(x => !!x).join('<br>');
    },
    scrollToSchedule() {
      let index = this.$route.query.index ?? null
      if (!index) {
        return
      }
      const schedule_element = document.getElementById(`schedule_${index}`);
      if (schedule_element) {
        schedule_element.scrollIntoView({behavior: 'smooth'});
      }
    },
    getCars(schedule){
      let cars = schedule.assigned_cars_by_schedule;
      let res = [];
      res = cars.map(function(car){
        return "["+car.hiragana + " " + car.number + "] " + car.name;
      });
      return res.join(" , ");
    },
    getStaffs(schedule){
      let staffs = schedule.assigned_staffs_by_schedule;
      let res = [];
      res = staffs.map(function(staff){
        return staff.user_name;
      });
      return res.join(" , ");
    }
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    showDate() {
      let dateOrigin = moment(this.filters.date, 'YYYY-MM-DD');
      return dateOrigin.format('YYYY年MM月DD日') + '（' + this.DAY_OF_WEEKS[dateOrigin.day()] + '）の作業';
    },
    showDayMonth() {
      let dateOrigin = moment(this.filters.date, 'YYYY-M-D');
      return dateOrigin.format('M月D日') + ' (' + this.DAY_OF_WEEKS[dateOrigin.day()] + ') の作業';
    },
    showSelectFactory() {
      if (! this.user) return false
      return this.user.department.zz_division_id === this.$constant.DEPARTMENT['environmental_management_department']
    },
    formatHour() {
      return dateTime => moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY/MM/DD HH:mm')
    },
    showBadge5: function () {
      const vm = this;
      return function (item) {
        if (vm.zzWorkOrderTypes === undefined || vm.zzWorkOrderTypes.length === 0) {
          vm.zzWorkOrderTypes = vm.options_tables.zz_work_order_types
        }
        let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null
        if (vm.zzWorkOrderTypes !== undefined && vm.zzWorkOrderTypes.length !== 0) {
          let result = vm.zzWorkOrderTypes.filter(value => {
            return value.id === zzWorkOrderTypeId;
          });
          if (result[0] === undefined) {
            return ' '
          }

          if (zzWorkOrderTypeId === vm.$constant.work_order_type.transshipment_storage) {
            let section = ''
            if (item.schedule.transport_and_hold_section === 1) {
              section = '１';
            } else if (item.schedule.transport_and_hold_section === 2) {
              section = '２';
            }
            return result[0]['work_order_type'] + section;
          }
          return result[0]['work_order_type'];
        }
        return ' '
      };
    },
    colorBadge5: function () {
      const vm = this;
      return function (item) {
        if (vm.zzWorkOrderTypes === undefined || vm.zzWorkOrderTypes.length === 0) {
          vm.zzWorkOrderTypes = vm.options_tables.zz_work_order_types
        }
        let zzWorkOrderTypeId =  item.work_order_json ? item.work_order_json.zz_work_order_type_id : null

        if (vm.zzWorkOrderTypes !== undefined && vm.zzWorkOrderTypes.length !== 0) {
          let result = vm.zzWorkOrderTypes.filter(value => {
            return value.id === zzWorkOrderTypeId;
          });
          if (result[0] === undefined) {
            return ''
          }
          return this.$constant.workOrderTypeBgColor[result[0]['id']];
        }
        return ''
      };
    },
    otherStatus7and0() {
      const vm = this;
      return function (item) {
        if (!item.work_order_json) return false
        const workOrderType = vm.$constant.work_order_type;
        return !(item.work_order_json.zz_work_order_type_id === workOrderType.work || item.work_order_json.zz_work_order_type_id === workOrderType.others);
      }
    },
    isStatus3() {
      const vm = this;
      return function (item) {
        if (!item.work_order_json) return false
        const workOrderType = vm.$constant.work_order_type;
        return item.work_order_json.zz_work_order_type_id === workOrderType.transportation_disposal;
      }
    },
    vendorSiteName() {
      if (this.data.length === 0) return ''
      if (this.data[0]['wastes_or_services_by_daily_report'][0] === undefined) return ''
      if (! this.data[0]['wastes_or_services_by_daily_report'][0]['vendor_site']) return ''
      return this.data[0]['wastes_or_services_by_daily_report'][0]['vendor_site']['name_abbreviated']
    },
    showUserName() {
      if (! store.getters['auth/user']) return ''
      return store.getters['auth/user']['user_name']
    },
    showNext() {
      if (this.conditionDate.length === 0) return false
      let conditionEnd = moment(this.conditionDate.end_datetime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      return this.filters.date < conditionEnd;

    },
    showPrev() {
      if (this.conditionDate.length === 0) return false
      let conditionStart = moment(this.conditionDate.start_datetime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
      return this.filters.date > conditionStart;

    },
    showStatusProcess() {
      var vm = this;
      return function (item) {
        if (! item.work_order_json) return false
        const workOrderType = vm.$constant.work_order_type;
        return item.work_order_json.zz_work_order_type_id === workOrderType.disposal;
      }
    },
    vendorName() {
      return function(item) {
        return this.getListName('vendor', item);
      }
    },
    vendorAddress() {
      return function(item) {
        return this.getListAddress('vendor', item)
      }
    },
    vendorSiteNameForList() {
      return function(item) {
        return this.getListName('vendor_site', item);
      }
    },
    vendorSiteAddress() {
      return function(item) {
        return this.getListAddress('vendor_site', item)
      }
    },
    showAddressDischarger() {
      return function(item) {
        let zip = this.$helpers.formatZipCode(item?.work_order_json?.case?.discharger?.zip)
        let address1 = item.work_order_json.case.discharger.address_1 === null ? '' : item.work_order_json.case.discharger.address_1
        let address2 = item.work_order_json.case.discharger.address_2 === null ? '' : item.work_order_json.case.discharger.address_2
        let address3 = item.work_order_json.case.discharger.address_3 === null ? '' : item.work_order_json.case.discharger.address_3
        let address4 = item.work_order_json.case.discharger.address_4 === null ? '' : item.work_order_json.case.discharger.address_4
        return zip + address1 + address2 + address3 + address4
      }
    },
    showAddressDischargerSite() {
      return function(item) {
        let zip = this.$helpers.formatZipCode(item?.work_order_json?.case?.discharger_site?.zip)
        let address1 = item.work_order_json.case.discharger_site.address_1 === null ? '' : item.work_order_json.case.discharger_site.address_1
        let address2 = item.work_order_json.case.discharger_site.address_2 === null ? '' : item.work_order_json.case.discharger_site.address_2
        let address3 = item.work_order_json.case.discharger_site.address_3 === null ? '' : item.work_order_json.case.discharger_site.address_3
        let address4 = item.work_order_json.case.discharger_site.address_4 === null ? '' : item.work_order_json.case.discharger_site.address_4
        return zip + address1 + address2 + address3 + address4
      }
    }
  }
};
</script>
